import React from 'react'
import Flex from 'typescript-styled-flex'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { ExpandButton } from '../../ColorPalette'
import { ReservationFormFieldVisibility } from '../../../containers/Form/CreateReservation/withReduxForm'
import VisibilityControlled from '../../../containers/Form/CreateReservation/Components/VisibilityControlled'
import Label from './Label'

function ExpandableSection({
  children,
  label,
  size = 1,
  fields,
  alwaysVisible,
}: IExpandableSectionProps) {
  const [expand, toggleExpand] = React.useState(false)

  function toggle() {
    toggleExpand(!expand)
  }

  return (
    <React.Fragment>
      <Flex
        row={true}
        alignCenter={true}
        style={{
          marginBottom: `${20 * size}px`,
          marginTop: `${20 * size}px`,
        }}
      >
        <Label size={size}>{label}</Label>
        <div
          style={{
            borderBottom: '1px solid #dfdfdf',
            margin: `0px ${20 * size}px`,
            width: '100%',
          }}
        />
        <VisibilityControlled field={fields}>
          <ExpandButton size={size} onClick={toggle}>
            {!expand ? (
              <FiChevronDown size={16 * size} />
            ) : (
              <FiChevronUp size={16 * size} />
            )}
          </ExpandButton>
        </VisibilityControlled>
      </Flex>
      {alwaysVisible}
      {expand && <Flex column={true}>{children}</Flex>}
    </React.Fragment>
  )
}

export default ExpandableSection

export interface IExpandableSectionProps {
  children: React.ReactNode | JSX.Element
  fields: (keyof ReservationFormFieldVisibility)[]
  alwaysVisible: React.ReactNode | JSX.Element
  label: string
  size?: number
}
